import { roundToDecimals } from '@/utils/common';

/**
 * Precio de lista de un plan con descuento, redondeado al dolar.
 *
 * El backend lo calcula como cost / (1 - discount), pero el discount es un
 * porcentaje redondeado: 109 al "35%" da 167.69 en vez de 168 (12 x 14). El
 * precio de lista real siempre es entero, y es el que usa la landing de Framer
 * para el "Save $59" (VEX-6997).
 */
export function listPrice(plan) {
  return Math.round(plan.originalCostWithoutDiscount);
}

/** Lo que se ahorra contra el precio de lista: lo que la landing llama "Save". */
export function listDiscountAmount(plan) {
  return roundToDecimals(listPrice(plan) - plan.originalCost);
}
